import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'name',
    label: i18n('entities.position.fields.name'),
    schema: schemas.string(
      i18n('entities.position.fields.name'),
      {
        "required": true,
        "max": 64
      },
    ),
  },
  {
    name: 'displayOrder',
    label: i18n('entities.position.fields.displayOrder'),
    schema: schemas.integer(
      i18n('entities.position.fields.displayOrder'),
      {},
    ),
  },
];